import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import {
  Box,
  Typography,
  Button,
} from '@mui/material';

import { withTranslation } from 'react-i18next';
// import i18n from '../assets/locales';

import Layout from '../layouts/layout.component';

type Props = {};

type State = {
  redirect: string | null,
};

class ForgotPasswordSuccess extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.routeChange = this.routeChange.bind(this);

    this.state = {
      redirect: null,
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    window.location.reload();
  }

  routeChange() {
    this.setState({
      redirect: '/signin'
    })
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    return (
      <Layout>
        <div className='container col-md-12'>
          <Box sx={{ height: 20 }} />
          <div className='container-fluid'>
            <Typography variant='h4'><b>Forgot password</b></Typography>
          </div>
          <div className='container card card-container' style={{background: 'transparent'}}>
            <Box sx={{ height: 20 }} />
            <Typography>Thanks - if you have a SquareGolf account, we've sent you an email.</Typography>
            <Box sx={{ height: 20 }} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div>
                <Button onClick={this.routeChange}>
                  Return to sign in
                </Button>
              </div>
            </Box>
            <Box sx={{ height: 20 }} />
          </div>
        </div>
      </Layout>
    );
  }
}

export default withTranslation()(ForgotPasswordSuccess)
